import { render, staticRenderFns } from "./AdminMarketCsgoItem.vue?vue&type=template&id=7b07ae28&scoped=true&"
import script from "./AdminMarketCsgoItem.vue?vue&type=script&lang=ts&"
export * from "./AdminMarketCsgoItem.vue?vue&type=script&lang=ts&"
import style0 from "./AdminMarketCsgoItem.vue?vue&type=style&index=0&id=7b07ae28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b07ae28",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QBtn,QInput});
